import { createBrowserRouter, RouteObject } from "react-router-dom";
import AdminPartnerTempSignUpPage from "../../features/admin/adminPartnerSignUp/AdminPartnerTempSignUp";
import T1aPartnersPage from "../../features/admin/adminUsers/T1aPartners";
import AdminCollectionReportPage from "../../features/admin/reports/collections/AdminCollectionReport";
import AppUserPage from "../../features/admin/users/AppUser";
import CollectionForm from "../../features/basicUser/basicUserForms/CollectionForm";
import KoReportingOverviewPage from "../../features/basicUser/koreporting/overview/KoReportingOverview";
import KoReportingPage from "../../features/basicUser/koreporting/reports/KoReporting";
import CollectionReportPage from "../../features/basicUser/reports/CollectionReport";
import UpReCycleChartPage from "../../features/basicUser/upcycleRecycleContainer/UpcycleRecycleContainer";
import UserProfile from "../../features/basicUser/UserProfilePage";
import HomePage from "../../features/home/HomePage";
import TermsAndConditions from "../../features/staticContents/TermsAndConditions";
import SubPartnerPage from "../../features/subPartner/SubPartner";
import EmailConfirmSuccessPage from "../../features/user/EmailConfirmSuccess";
import ReferralSignupFormPage from "../../features/user/forms/ReferralSignupForm";
import RegisterSignupFormPage from "../../features/user/forms/RegisterSignupForm";
import ResetPasswordFormPage from "../../features/user/forms/ResetPasswordForm";
import ResetPasswordValidatePage from "../../features/user/forms/ResetPasswordValidate";
import SignUpFormPage from "../../features/user/forms/SignUpForm";
import ChangePasswordPage from "../../features/user/password/ChangePassword";
import RegisterSuccessPage from "../../features/user/RegisterSuccess";
import ProfilePhotoPage from "../../features/userProfile/ProfilePhoto";
import App from "../layout/App";
import AdminTempUserResgisterPage from "../../features/admin/adminTempUserRegisters/AdminTempUserResgister";
import NotFoundPage from "../../features/errors/NotFound";
import SuccessSignupPage from "../../features/staticContents/SuccessSignup";
import { RequiredAdminAuth } from "./RequiredAdminAuth";
import { RequiredAuth } from "./RequiredAuth";
import CollectionReportDetailPage from "../../features/basicUser/reports/CollectionReportDetail";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            {element: <RequiredAdminAuth />, children: [
                { path: '/adminuserspanel', element: <AppUserPage /> },
                { path: '/admincollection', element: <AdminCollectionReportPage /> },
                { path: '/admintempsignups', element: <AdminTempUserResgisterPage /> },
            ]},
            {element: <RequiredAuth />, children: [
                { path: "/kooverview", element: <KoReportingOverviewPage /> },
                { path: "/koreports", element: <KoReportingPage /> },
                { path: "/newcollection", element: <CollectionForm /> },
                { path: "/collectionstatus", element: <CollectionReportPage /> },
                { path: "/collectionstatus/:id", element: <CollectionReportDetailPage /> },
                { path: '/uprecycleview', element: <UpReCycleChartPage /> },
                { path: "/password", element: <ChangePasswordPage /> },
                { path: '/adminProfile', element: <UserProfile /> },
            ]},
            { path: '/', element: <HomePage /> },           
            { path: '/successsignup', element: <SuccessSignupPage/> },
            { path: '/newadminuserpanel', element: <T1aPartnersPage /> },
            { path: '/newsubpartneruserpanel', element: <SubPartnerPage /> },
            { path: '/newadmintempsignup', element: <AdminPartnerTempSignUpPage /> },
            { path: '/account/signupReferal', element: <ReferralSignupFormPage /> },
            { path: '/account/signupRequest', element: <RegisterSignupFormPage /> },
            { path: '/signup', element: <SignUpFormPage /> },
            { path: '/termsandconditions', element: <TermsAndConditions /> },          
            { path: '/newUser/registerSuccess', element: <RegisterSuccessPage /> },
            { path: '/account/verifyEmail', element: <EmailConfirmSuccessPage /> },
            { path: "/userPassword/resetPassword", element: <ResetPasswordFormPage /> },
            { path: "/userPasswordReset/resetValidate", element: <ResetPasswordValidatePage /> },
           
            
            { path: "/photo", element: <ProfilePhotoPage /> },
        
            { path: '*', element: <NotFoundPage /> }

        ]
    }
]

export const router = createBrowserRouter(routes);
